import { Pageheader } from './global-components/page-header';
import ContactForm from './section-components/contact-form';
import bgImage from '../assets/img/banner/contact.webp';

const ContactPage = () => {
    return <div>
        <Pageheader headertitle="Contact" bgImage={bgImage} />
        <ContactForm />
    </div>
}

export default ContactPage

